export default [{
		id: '01',
		value: '01',
		label: '营业执照'
	}, {
		id: '02',
		value: '02',
		label: '税务登记证'
	}, {
		id: '03',
		value: '03',
		label: '组织机构代码证'
	}, {
		id: '04',
		value: '04',
		label: '卫生许可证'
	}, {
		id: '05',
		value: '05',
		label: '生产许可证'
	}, {
		id: '06',
		value: '06',
		label: '食品经营许可证'
	}, {
		id: '07',
		value: '07',
		label: '检验报告'
	}, {
		id: '08',
		value: '08',
		label: 'ISO认证证书'
	}, {
		id: '09',
		value: '09',
		label: '商标注册证'
	}, {
		id: '10',
		value: '10',
		label: '健康证'
	}, {
		id: '11',
		value: '11',
		label: '其他'
	}
]

